module.exports = __webpack_public_path__ + "img/@logo_kbbank.bf6f60f4.svg";